import { GregorioClefType } from '../enums/GregorioClefType';
import { GregorioType } from '../enums/GregorioType';
import { GregorioClefInfo } from '../structures/GregorioClef';
import { GregorioSegment } from '../structures/GregorioSegment';
import { GregorioElement, GregorioSyllable } from '../structures/GregorioSyllable';

export function get_default_clef(): GregorioSyllable {
  const clefInfo = new GregorioClefInfo();
  clefInfo.line = 3;
  clefInfo.secondary_line = 0;
  clefInfo.pitch_difference = 0;
  clefInfo.clef = GregorioClefType.C;
  clefInfo.flatted = false;
  clefInfo.secondary_clef = GregorioClefType.C;
  clefInfo.secondary_flatted = false;

  const element = new GregorioElement();
  element.misc.clef = clefInfo;
  element.type = GregorioType.CLEF;

  const segment = new GregorioSegment();
  segment.elements = [
    element
  ];

  const syllable = new GregorioSyllable();
  syllable.segments = [
    segment,
  ];
  
  return syllable;
}
